import { API_URL } from "../config/connect";

const getAuthHeaders = () => {
  const token = localStorage.getItem('google_id_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Chat types
export const CHAT_TYPES = {
  PROMOTIONS: 'PROMOTIONS',
  AGROLAND_KZ: 'AGROLAND_KZ',
  SUPPORT_OPERATOR: 'SUPPORT_OPERATOR',
  AGROLAND_GUIDE: 'AGROLAND_GUIDE',
  NEWS: 'NEWS'
};

// Chat type names mapping
export const CHAT_TYPE_NAMES = {
  PROMOTIONS: 'Акции',
  AGROLAND_KZ: 'Agroland.kz',
  SUPPORT_OPERATOR: 'Чат с оператором',
  AGROLAND_GUIDE: 'Чат с Agroland Гид',
  NEWS: 'Новости'
};

/**
 * Send message to all users
 * @param {Object} data - Message data
 * @param {string} data.message - Message text
 * @param {string} data.message_type - Message type (e.g., "text")
 * @param {string} data.chat_type - Chat type (PROMOTIONS, AGROLAND_KZ, etc.)
 * @returns {Promise<Object>} Response with sent count and errors
 */
export const sendMessageToAll = async (data) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/system-chats/send-to-all`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error sending message to all users:', error);
    throw error;
  }
};

/**
 * Send message to a specific user
 * @param {Object} data - Message data
 * @param {string} data.message - Message text
 * @param {string} data.message_type - Message type (e.g., "text")
 * @param {string} data.chat_type - Chat type
 * @param {number} data.user_id - User ID
 * @returns {Promise<Object>} Response with message details
 */
export const sendMessageToUser = async (data) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/system-chats/send-to-user`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error sending message to user:', error);
    throw error;
  }
};

/**
 * Send message to multiple users
 * @param {Object} data - Message data
 * @param {string} data.message - Message text
 * @param {string} data.message_type - Message type (e.g., "text")
 * @param {string} data.chat_type - Chat type
 * @param {number[]} data.user_ids - Array of user IDs
 * @returns {Promise<Object>} Response with sent count and errors
 */
export const sendMessageToMultiple = async (data) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/system-chats/send-to-multiple`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error sending message to multiple users:', error);
    throw error;
  }
};

/**
 * Get system chats information
 * @returns {Promise<Object>} Response with system chats data
 */
export const getSystemChatsInfo = async () => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/system-chats/info`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching system chats info:', error);
    throw error;
  }
};

